import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classes from './SourceDisplay.module.scss';

const RememberButtons = (props) => {
  const {
    defaultVideoSetting,
    defaultAudioSetting,
    setVideoEnabledDefault,
    setAudioEnabledDefault,
    isPSTNVisible,
    type,
    toggleAudio,
    toggleVideo
  } = props;
  return (
    <div className={classes.rememberButtons}>
      {type === 'video' &&
        <section className={classes.rememberBar}>
          <button
            className={classes.switch}
            onClick={() => {
              toggleVideo(!defaultVideoSetting);
              setVideoEnabledDefault(!defaultVideoSetting);
            }}
          >
            <FormattedMessage
              id="components.avSettingsModal.cameraOption"
              defaultMessage="Camera"
            />
            <input
              id="cameraOn"
              className={classes.flatSwitch}
              type="checkbox"
              checked={defaultVideoSetting}
              readOnly
            />
            <label htmlFor="cameraOn" />
          </button>
        </section>
      }
      {
        (!isPSTNVisible && type === 'audio') &&
        <section className={classes.rememberBar}>
          <button
            className={classes.switch}
            onClick={() => {
              toggleAudio(!defaultAudioSetting);
              setAudioEnabledDefault(!defaultAudioSetting);
            }}
          >
            <FormattedMessage
              id="components.avSettingsModal.microphoneOption"
              defaultMessage="Microphone"
            />
            <input
              id="audioOn"
              name="audioOn"
              className={classes.flatSwitch}
              type="checkbox"
              checked={defaultAudioSetting}
              readOnly
            />
            <label htmlFor="audioOn" />
          </button>
        </section>
      }
    </div>
  );
};

RememberButtons.propTypes = {
  setVideoEnabledDefault: PT.func.isRequired,
  setAudioEnabledDefault: PT.func.isRequired,
  defaultVideoSetting: PT.bool.isRequired,
  defaultAudioSetting: PT.bool.isRequired,
  isPSTNVisible: PT.bool,
  type: PT.string,
  toggleAudio: PT.func,
  toggleVideo: PT.func
};

RememberButtons.defaultProps = {
  sections: {
    camera: true,
    audio: true
  }
};


export default RememberButtons;
